/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import {
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress,
} from '@material-ui/core';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';

import Button from 'components/Button';

import { composeStyles } from 'features/Theme';

import styles from '../styles';

interface NotBestAprDialogPropTypes {
  notBestAprContent: string;
  onSendEmailClick: () => void;
  sendingEmail: boolean;
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
}

const NotBestAprDialog: React.FC<NotBestAprDialogPropTypes> = props => {
  const {
    notBestAprContent,
    onSendEmailClick,
    sendingEmail,
    modalOpen,
    setModalOpen,
  } = props;

  const tMd = useMarkdownTranslate();
  return (
    <Dialog maxWidth="xs" open={modalOpen} onClose={() => setModalOpen(false)}>
      <DialogContent>
        <div
          css={styles.notBestAprContent}
          dangerouslySetInnerHTML={{ __html: notBestAprContent }}
        />
      </DialogContent>

      <DialogActions>
        <button
          disabled={sendingEmail}
          onClick={onSendEmailClick}
          css={composeStyles([styles.link, styles.emailLink])}
        >
          {sendingEmail ? (
            <CircularProgress aria-label="progress" size={16} />
          ) : (
            tMd('dsp.dspContent.emailDisclosures')
          )}
        </button>

        <Button
          onClick={() => setModalOpen(false)}
          css={styles.modalCloseButton}
          variant="text"
          autoFocus
        >
          {tMd('dsp.dspContent.closeDisclosures')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotBestAprDialog;
